var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.742969C0 0.552864 0.0670161 0.362759 0.199681 0.21721C0.467746 -0.0724032 0.899932 -0.0724032 1.168 0.21721L2.99932 2.20737L4.832 0.21721C5.10007 -0.0724032 5.53225 -0.0724032 5.79895 0.21721C6.06702 0.508308 6.06702 0.977629 5.79895 1.26873L3.48347 3.78316C3.35491 3.92277 3.18122 4 2.99932 4C2.81878 4 2.64509 3.92277 2.51653 3.78316L0.199681 1.26873C0.0670161 1.12318 0 0.933073 0 0.742969Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.d578396d340c7ff322e66984ba5f6013.svg";
export { ForwardRef as ReactComponent };